// In-memory only. Never localStorage / sessionStorage (ADR-0005).
let accessToken: string | null = null;
let resetToken: string | null = null;

export const tokenStore = {
  getAccessToken: (): string | null => accessToken,
  setAccessToken: (token: string | null): void => {
    accessToken = token;
  },
  getResetToken: (): string | null => resetToken,
  setResetToken: (token: string | null): void => {
    resetToken = token;
  },
  clear: (): void => {
    accessToken = null;
    resetToken = null;
  },
};
